import AutoSubmit from "@stimulus-components/auto-submit";

export default class extends AutoSubmit {
  static values = {
    delay: {
      type: Number,
      default: 100,
    },
  };

  static targets = ["textarea"];

  submit() {
    super.submit();
    this.textareaTarget.blur();
    this.textareaTarget.classList.add("ring-green-500", "ring-2");
    setTimeout(() => {
      this.textareaTarget.classList.remove("ring-green-500", "ring-2");
    }, 1200);
  }
}
